import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12874a10"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "header-center"
};
const _hoisted_4 = {
  class: "navs"
};
const _hoisted_5 = ["onClick", "onMouseenter"];
const _hoisted_6 = {
  class: "header-right"
};
const _hoisted_7 = {
  class: "second-nav_box w"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space"
}, null, -1));
import { navList } from '@/config/home';
import { getStorage, setStorage } from '@/utils/storage';
import { useHomeStore } from '@/pinia/index';
import { useThrottleFn } from '@vueuse/core';
import { UPLOADFILEURL } from '@/api/baseURL';
import info from '@/components/info/index.vue';

import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
// import {incrementPageCount} from '@/utils/visit'

export default {
  __name: 'index',
  props: {
    isScroll: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const homeStore = useHomeStore();
    const router = useRouter();
    const isShow = ref(false);
    const secondNavList = ref([]);
    let isMouseInsideSecondNav = ref(false);
    const handleNavMouseOver = item => {
      if (item.children && item.children.length) {
        homeStore.$state.currentHomeUrl = item.url;
        isShow.value = true;
        secondNavList.value = item.children;
      } else {
        isShow.value = false;
        secondNavList.value = [];
      }
    };
    const handleNavMouseLeave = e => {
      if (e.offsetY < 0) {
        isShow.value = false;
        secondNavList.value = [];
      }
    };
    const handleSecondNavMouseEnter = () => {
      isMouseInsideSecondNav.value = true;
    };
    const handleSecondNavMouseLeave = () => {
      isMouseInsideSecondNav.value = false;
      isShow.value = false;
      secondNavList.value = [];
    };
    const currentIndex = ref(getStorage('currentIndex') || 0);
    const handleClick = (item, index) => {
      // if (flag) {
      //   if (index > 1 && index != 4 && index != 3 && index != 7 && index != 2 && index != 6) {
      //   showToast();
      //     return;
      //   }
      // } else {
      if (!item.url) {
        showToast();
        return;
      }
      // }

      if ((route.path === '/home' || route.path === '/') && item.name === '首页') {
        router.go();
      }
      const hasChild = item.children && item.children.length;
      // console.log('item, index', item, index, hasChild);
      if (hasChild) return;
      const {
        isOpenNewWindow
      } = item;
      //设置模块名字 主要用于因研究报告需求更改 是否显示首页导航（./industry/index中）
      setStorage('title', item.name);
      // 行业领域 需要新开页面
      if (isOpenNewWindow) {
        const {
          href
        } = router.resolve({
          path: item.url
        });
        window.open(href, '_blank');
        setStorage('currentIndex', index);
        if (item.url !== '/major') {
          setStorage('navName', item.name);
        }

        //新开页面记录
        // incrementPageCount()
      }
      // 不需要新开页面
      else if (!isOpenNewWindow) {
        item.pid ? currentIndex.value = navList.findIndex(obj => obj.id === item.pid) : currentIndex.value = index;
        setStorage('currentIndex', currentIndex.value);
        // homeStore.$state.currentHomeIndex = item.id;
        //homeStore.$state.currentHomeUrl = item.url;
        router.push(item.url);
      }
    };
    const showToast = useThrottleFn(() => {
      ElMessage({
        message: '功能陆续上线，敬请期待',
        type: 'info',
        duration: 700,
        customClass: 'messageIndex'
      });
    }, 700);
    const route = useRoute();
    const handleHome = () => {
      if (route.path === '/home' || route.path === '/') {
        router.go();
      }
      setStorage('currentIndex', 0);
      homeStore.$state.currentHomeUrl = '/home';
      router.push('/');
    };
    const file = ref({});
    onMounted(() => {
      file.value = getStorage('currentDetailInfo')?.file;

      // api.getSystemConfig().then((res) => {
      //   if (res.data.code === 200) {
      //     file.value = res.data.data.file;
      //   }
      // });
    });

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(props.isScroll ? 'bg' : 'headers'),
        ref: "headers"
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        onClick: handleHome,
        class: "header-left",
        src: `${_unref(UPLOADFILEURL)}?id=${_unref(file)?.id}`,
        alt: "logo"
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["nav-item", [_unref(homeStore).$state.currentHomeUrl === item.url || _unref(homeStore).$state.currentHomeIndex === item.id ? 'active' : '']]),
          onClick: $event => handleClick(item, index, true),
          onMouseenter: $event => handleNavMouseOver(item),
          onMouseleave: handleNavMouseLeave
        }, [_createElementVNode("span", null, _toDisplayString(item.name), 1)], 42, _hoisted_5);
      }), 128))])]), _createElementVNode("div", _hoisted_6, [_createVNode(info)])]), _createElementVNode("div", {
        class: _normalizeClass(["second-nav", {
          active: _unref(isShow)
        }]),
        onMouseenter: handleSecondNavMouseEnter,
        onMouseleave: handleSecondNavMouseLeave
      }, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondNavList), (child, i) => {
        return _openBlock(), _createElementBlock("span", {
          key: child.id,
          onClick: $event => handleClick(child, i, false)
        }, _toDisplayString(child.name), 9, _hoisted_8);
      }), 128))])], 34)], 2), _hoisted_9], 64);
    };
  }
};